import * as React from 'react'

const PdfIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      fill="none"
      viewBox="0 0 22 24"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_7337_43619)">
        <path
          fill="#E9F0FA"
          d="m17 0 4 4v19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        ></path>
        <path fill="#C2CDDE" d="M21 4h-4V0z"></path>
      </g>
      <rect width="22" height="10" y="10" fill="#F14848" rx="1"></rect>
      <path
        fill="#fff"
        d="M3.757 18v-5.818H5.94q.67 0 1.125.25.457.25.69.687.237.435.236.989 0 .56-.235.994-.237.435-.696.685-.46.247-1.134.247H4.48v-.866h1.304q.392 0 .642-.137a.86.86 0 0 0 .37-.375q.121-.239.122-.548 0-.31-.123-.546a.83.83 0 0 0-.372-.366q-.249-.133-.645-.133h-.966V18zm7.12 0H8.907v-5.818h2.011q.867 0 1.489.35.626.346.96.996.336.651.335 1.557 0 .909-.338 1.563-.335.653-.968 1.003-.631.35-1.517.349m-.917-.912h.866q.609 0 1.015-.222.406-.225.61-.667.205-.447.205-1.114t-.205-1.108a1.4 1.4 0 0 0-.605-.662q-.397-.22-.988-.221H9.96zm4.743.912v-5.818h3.727v.883h-2.673v1.58h2.417v.883h-2.417V18z"
      ></path>
      <defs>
        <clipPath id="clip0_7337_43619">
          <path fill="#fff" d="M1 0h20v24H1z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
)

PdfIcon.displayName = 'PdfIcon'

export { PdfIcon }
